module.exports = __webpack_public_path__ + "static/img/performance_1.a4f3eeb1.jpg";